export default {"src":"/card/_next/static/media/lcro.c398dc61.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};